export enum CodeValidatedActionEnum {
  SIGN_UP = 'signUp',
  RESET_PASSWORD = 'resetPassword',
  DELETE_ACCOUNT = 'deleteAccount',
  CHANGE_PHONE = 'changePhone',
  CHANGE_EMAIL = 'changeEmail',
  CONFIRM_PHONE = 'confirmPhone',
  SIGN_DOCUMENT = 'signDocument',
  CREATE_REGISTER = 'createRegister',
  DELETE_REGISTER = 'deleteRegister',
  OUT_OFFER_AMOUNT = 'outOfferAmount',
  CREATE_COUNTER = 'createCounter',
  OFFER_DECLINE = 'offerDecline',
  ACCOUNT_AMOUNT = 'accountAmount',
  REQUEST_ALL_ACCOUNT_TOKENS = 'requestAllAccountTokens',
  IDENTIFICATION_CONFIRM = 'identification',
  REVOKE_COUNTER = 'revokeCounter',
  DEACTIVATE_PIN = 'deactivatePin',
}
